<template>
  <div class="footer">
    <div class="app-container">
      <div class="footer-wrapper flex-start">
        <div class="footer-title flex-start">
          <!-- <img
            v-if="itemname !== 'Mbuy'"
            :src="itemname == 'AntMall' ?require(`@/assets/image/${itemname}/logo.svg`): itemname == 'TikTok' || itemname == 'Shop2u' ?require(`@/assets/image/${itemname}/logo.png`):itemname == 'Laz' ?require(`@/assets/image/${itemname}/logo1.svg`):require(`@/assets/image/${itemname}/shoplogo.svg`)"
            :style="itemname == 'SM-wholesale shop'?'height:38px': itemname === 'TikTok' || itemname === 'TikTok-Wholesale' ? 'width: 276px;height: 66px;' : itemname === 'Shop2u' ? 'height: 42px' :''"
            alt=""
            @click="goHome"
          /> -->
          <!-- <img width="200" height="800" data-v-70ba1c7f="" src="data:image/png;base64,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" style="display: inline-block; border-radius: 0px; margin-bottom: 16px;"> -->
          <img style="width:158px;height: 158px;"  src="@/assets/image/shop-h5.png" alt="" @click="goHome" />
          <p style="width:158px;text-align: center;" >手机访问</p>
          <!-- <el-input
            v-model="email"
            :placeholder=" $t('message.home.yourEmail')"
            @input="identification"
          ></el-input>
          <div class="sub" @click="subScription">
            {{ $t("message.home.subscription") }}
          </div> -->
        </div>
        <div class="footer-nav">
          <div
            class="footer-nav-item"
            v-for="(item, index) in linkNav"
            :key="index"
          >
            <span>{{ item?.title }}</span>
            <ul>
              <el-tooltip
                v-for="(childItem, childIndex) in item?.nav"
                effect="light"
                :placement="
                  childItem.name == $t('message.home.contactUs') ? 'left' : ''
                "
                :key="childIndex"
              >
                <div slot="content" v-if="itemname !== 'SM-wholesale shop' && itemname !== 'Argos' && itemname!== 'INT Overstock'">
                  Tel/Weixin :16619915737
                </div>
                <div slot="content" v-else-if="itemname == 'SM-wholesale shop'">
                   {{ $t("message.home.businessEmail") }}: {{'support@justshop01.com'}}
                   <br>
                   {{ $t("message.home.businessEmail") }}2: {{'support@justshop02.com'}}
                </div>
                <div slot="content" v-else-if="itemname == 'Argos'">
                   {{ $t("message.home.businessEmail") }}: {{bassEmail}}
                   <br>
                   Telegram: Argos002
                   <br>
                   Line: Argos061
                   <br>
                   WhatsApp: +44 7477 466470
                </div>
                <div slot="content" v-else>
                   {{ $t("message.home.businessEmail") }}: CoveBuy@CoveBuy.cn
                   <!-- <br>
                   {{ $t("message.home.企业电话") }}: +1(840) 800-1088 -->
                </div>
                <li @click="childItem.clickEvent">
                  {{ childItem.name }}
                </li>
              </el-tooltip>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-wrapper">
        <div class="flex-start sec">
          <!-- <div class="payment">
            <div class="title-f">{{ $t("message.home.paymethods") }}</div>
            <div class="payment-methods">
              <div
                class="pay"
                v-for="(item, index) in payList"
                :key="index"
                @click="item.clickEvent"
              >
                <img :src="item?.img" alt="" />
                <span>{{ item?.name }}</span>
              </div>
            </div>
          </div> -->
          <div class="argos">
            <div class="left">
              <div class="title">{{ itemname == 'TikTok'?'TikTok Mall': itemname }}</div>
              <div class="dec">
                {{ itemname == 'TikTok' ? $t("message.home.TikTokFoot") :$t("message.home.footdec", { name: itemname,num: itemname == 'INT Overstock' ? 180 : 112 ,coin: itemname == 'Argos' || itemname == 'INT Overstock' ? 'USDT/USDC/ETH/BTC':'USDT/ETH/BTC'}) }}
              </div>
            </div>
            <div
              class="right"
              v-if="itemname !== 'Inchoi' && itemname !== 'Tongda' && itemname !== 'FamilyMart' && itemname !== 'Hive' && itemname !== 'Green Mall'&& itemname !== 'SM-wholesale shop' && itemname !== 'INT Overstock' && itemname !== 'TikTok-Wholesale' && itemname !=='CoveBuy'"
            >
              <img v-if="itemname !== 'Shop2u'" src="@/assets/image/BankCard.png" alt="" />
              <img v-else src="@/assets/image/Shop2ufoot.png" alt="" >
            </div>
          </div>
        </div>
        <div
          :class="itemname == 'Tongda' ? 'sec-img img-sec':itemname == 'SM-wholesale shop' ? 'sec-img just-img' : 'sec-img just-img'"
          v-if="itemname !== 'Mbuy' && itemname !== 'Hive'&& itemname !== 'Green Mall'&&itemname !== 'INT Overstock' && itemname !== 'TikTok-Wholesale'"
        >
          <img
            v-for="(i, index) in logoList"
            :key="index"
            :src="i.url"
            alt=""
            @click="i.clickEvent"
          />
        </div>
      </div>
      <div class="footer-bottom" v-if="itemname !== 'INT Overstock'">
        <p style="text-align: center; margin-bottom: 15px">
          {{ itemname !== 'TikTok'?$t("message.home.footTip", { name: itemname }):$t("message.home.footTipTikTok") }}
        </p>
        <!-- <p style="text-align:center">
          CoveBuy is headquartered in Ottawa, 151 O'Connor Street, Ground Floor, Canada, and has 6 office locations.
        </p> -->
      </div>
      <div class="footer-bottom" v-else>
        <p style="text-align: center; margin-bottom: 15px">
          © Copyright 2024, overstock8.me®, Inc.
        </p>
        <p style="text-align: center;">
          799 Coliseum Way Midvale, UT 84047 | 1-840-800-1088
        </p>
      </div>
    </div>
    <EsOnlineServiceView v-model="showOnlieService" ref="footerService"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { apiGetCustomerService } from "@/api/common";
import bn from "@/assets/image/bn.png";
import hb from "@/assets/image/hb.png";
import oy from "@/assets/image/oy.png";
import kk from "@/assets/image/kk.png";
import cb from "@/assets/image/cb.png";
import hl from "@/assets/image/hl.png";
import kc from "@/assets/image/kc.png";
import bf from "@/assets/image/bf.png";
import bit from "@/assets/image/bit.png";
import crypto from "@/assets/image/crypto.png";
import maicoin from "@/assets/image/maiCoin.png";
import Shop2u from "@/assets/image/Shop2u/logo.png"

import argos from "@/assets/image/argos.png";
import hab from "@/assets/image/hab.png";
import tu from "@/assets/image/tu.png";
import sains from "@/assets/image/sains.png";
import nectar from "@/assets/image/nectar.png";
import clogo from "@/assets/image/clogo.png";
// import { sub } from "@/api/home";
// import amazon from "@/assets/image/amazon.png";
// import justeat from "@/assets/image/justeat.png";
import zd from "@/assets/image/zd.png"
import zelle from "@/assets/image/zelle.png"
import bdo from "@/assets/image/bdo.png"
import CoveBuy from "@/assets/image/covebuy.png"
export default {
  name: "EsFooter",
  data() {
    const JumpToLogin = () => {
      if (!this.isLogin) {
        this.$router.push("/register");
      } else {
        this.$router.push("/login");
      }
    };

    const JumpTo = (path, index) => {
      if (this.isLogin) {
        this.$router.push(path);
        // this.$store.state.user.currentIndex = index;
      } else {
        this.$router.push("/login");
      }
    };
    return {
      itemname: process.env.VUE_APP_ITEM_NAME,
      bassEmail: "",
      email: "",
      logoList: [
        {
          url: CoveBuy,
          clickEvent: () => {
           location.reload();
          },
        },
        {
          url: require("@/assets/image/testBanner/亚马逊.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':process.env.VUE_APP_ITEM_NAME !== 'SM-wholesale shop' ?window.open("https://www.bdo.com/", "_blank"):
            window.open("https://www.amazon.com/", "_blank");
          },
        },
        {
          url: require("@/assets/image/testBanner/ebay.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':
            window.open("https://www.ebay.com/", "_blank");
          },
        },
        {
          url: require("@/assets/image/testBanner/速卖通.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':
            window.open("https://www.aliexpress.com/", "_blank");
          },
        },
        {
          url: require("@/assets/image/testBanner/shopee.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':
            window.open("https://shopee.com/", "_blank");
          },
        },
        {
          url: require("@/assets/image/testBanner/lazada.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':
            window.open("https://www.lazada.com/ ", "_blank");
          },
        },
        {
          url: require("@/assets/image/testBanner/ozon.png") ,
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Shop2u"
              ? '':
            window.open("https://www.szon.ru/", "_blank");
          },
        },
        // {
        //   url: require("@/assets/image/testBanner/速卖通.jpg") ,
        //   clickEvent: () => {
        //      process.env.VUE_APP_ITEM_NAME == "Shop2u"
        //       ? '':
        //     window.open("https://www.zellepay.com/", "_blank");
        //   },
        // }
        
      ],
      linkNav: [
        {
          title: this.$t("message.home.custService"),
          nav: [
            // {
            //   name: this.$t("message.home.helpLine"),
            //   path: "",
            //   clickEvent: () => {
            //     window.open(
            //           window.origin + "/#/doc?docId=1560222661872078849",
            //           "_blank"
            //         );
            //   },
            // },

            {
              name:this.$t("message.home.App下载(买家端)"),
              path: "",
              clickEvent: () => {
                window.open(
                      window.origin + "/pc/#/doc?docId=1863184824988319746",
                      "_blank"
                    );
              },
            },
            {
              name: this.$t("message.home.App下载(卖家端)"),
              path: "",
              clickEvent: () => {
                window.open(
                      window.origin + "/pc/#/doc?docId=1863185730509193217",
                      "_blank"
                    );
              },
            },
          ],
        },
        {
          title: this.$t("message.home.returnsAndEx"),
          nav: [
            // {
            //   name: this.$t("message.home.privacyPolicy"),
            //   path: "",
            //   clickEvent: () => {
            //     window.location.href =
            //       window.origin +
            //         "/promote/#/privacyPolicy?lang=" +
            //         this.lang || "en" + "&avatar=" + this.userInfo.avatar;
            //   },
            // },
            {
              name: this.$t("message.home.returnPolicy"),
              path: "",
              clickEvent: () => {
                window.open(
                      window.origin + "/pc/#/doc?docId=1863051445957541889",
                      "_blank"
                );
              },
            },
            {
              name: this.$t("message.home.delivery"),
              path: "",
              clickEvent: () => {
                window.open(
                      window.origin + "/pc/#/doc?docId=1863052220733571074",
                      "_blank"
                );
              },
            },
            {
              name: this.$t("message.home.sellerRules"),
              path: "",
              clickEvent: () => {
                window.open(
                      window.origin + "/pc/#/doc?docId=1863054090399105026",
                      "_blank"
                );
              }
            }
              // clickEvent: () => {
                // window.location.href =
                  // window.open + "/#/doc?docId=1863054090399105026";
              // },
            // },
            // {
            //   name: this.$t("message.home.sellerRules"),
            //   path: "",
            //   clickEvent: () => {
            //       this.$router.push({
            //         path: '/doc',
            //         query: {docId: '1863054090399105026'}
            //       });
            //   },
            // },
            // {
            //   name: this.$t("message.home.sellerRules"),
            //   path: "",
            //   clickEvent: () => {
            //     window.location.href =
            //       window.origin +
            //         "/promote/#/shippingPolicy?lang=" +
            //         this.lang || "en" + "&avatar=" + this.userInfo.avatar;
            //   },
            // },
          ],
        },
        {
          title: this.$t("message.home.user_Center"),
          nav: [
            {
              name: this.$t("message.home.userReg"),
              path: "",
              clickEvent: () => JumpToLogin(),
            },
            {
              name: this.$t("message.home.orderTrack"),
              path: "",
              clickEvent: () => JumpTo("/userInfo/my-order?index=2", 2),
            },
            {
              name: this.$t("message.home.myCommodityCollection"),
              path: "",
              clickEvent: () => JumpTo("/userInfo/collect-goods?index=3", 3),
            },
            // {
            //   name: this.$t("message.home.myPurse"),
            //   path: "",
            //   clickEvent: () => JumpTo("/userInfo/money-package?index=1", 1),
            // },
          ],
        },
        {
          title: this.$t("message.home.aboutUs"),
          nav: [
            {
              name: this.$t("message.home.aboutUs"),
              path: "",
              clickEvent: () => {
                window.open(
                      "https://www.covebuy.cn",
                      "_blank"
                    );
              },
            },            
            {
              name: this.$t("message.home.contactUs"),
              path: "",
              clickEvent: () => {
                window.open(
                      "https://www.covebuy.cn/lianxiwomen",
                      "_blank"
                    );
              },
            },
            // {
            //   name:this.$t("message.home.news"),
            //   path: "",
            //   clickEvent: () => {
            //     window.open(
            //           "https://www.covebuy.cn/xinwenzhongxin",
            //           "_blank"
            //         );
            //   },
            // },
            // {
            //   name: process.env.VUE_APP_ITEM_NAME == 'INT Overstock' ? '':process.env.VUE_APP_ITEM_NAME == 'Shop2u' ? 'YouTube' : this.$t("message.home.stateMent"),
            //   path: "",
            //   clickEvent: () => {
            //     process.env.VUE_APP_ITEM_NAME == 'Shop2u' ? window.open('https://www.youtube.com/@shop2u','_blank'):
            //     window.open(
            //       "https://www.about.sainsburys.co.uk/sustainability/plan-for-better/our-stories/2017/standing-up-to-modern-slavery",
            //       "_blank"
            //     );
            //   },
            // },
          ],
        },
      ],
      payList: [
        {
          img: bn,
          name: "Binance",
          clickEvent: () => {
            window.open("https://www.binance.com", "_blank");
          },
        },
        {
          img: hb,
          name: "Huobi",
          clickEvent: () => {
            window.open("https://www.huobi.com/en-us/", "_blank");
          },
        },
        {
          img: oy,
          name: "OKX",
          clickEvent: () => {
            window.open("https://www.okx.com", "_blank");
          },
        },
        {
          img: kk,
          name: "KraKen",
          clickEvent: () => {
            window.open("https://www.kraken.com", "_blank");
          },
        },
        {
          img: cb,
          name: "Coinbase",
          clickEvent: () => {
            window.open("https://www.coinbase.com", "_blank");
          },
        },
        {
          img: process.env.VUE_APP_ITEM_NAME == "Hive" || process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale' ? bit : process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? crypto : hl,
          name: process.env.VUE_APP_ITEM_NAME == "Hive" ? 'Bitoex':process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? 'Crypto' : "MetaMask",
          clickEvent: () => {
            process.env.VUE_APP_ITEM_NAME == "Hive" || process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale'? window.open("https://www.bitoex.com/", "_blank"):
            process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? window.open("https://crypto.com/", "_blank"):
            window.open("https://metamask.io/", "_blank");
          },
        },
        {
          img: process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? bit : kc,
          name: process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? "Bitopro":"KuCoin",
          clickEvent: () => {
             process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? window.open("https://www.bitopro.com", "_blank"):
            window.open("https://www.kucoin.com ", "_blank");
          },
        },
        {
          img:process.env.VUE_APP_ITEM_NAME == "Hive" || process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale'? maicoin:process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? maicoin: bf,
          name: process.env.VUE_APP_ITEM_NAME == "Hive" || process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale'? "Bitfinex":process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? "MaiCoin":"Bitfinex",
          clickEvent: () => {
            process.env.VUE_APP_ITEM_NAME == "Hive"|| process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale' ? window.open("https://max.maicoin.com/", "_blank"):
            process.env.VUE_APP_ITEM_NAME == "Argos" ||process.env.VUE_APP_ITEM_NAME == "ArgosShop" ? window.open("https://max.maicoin.com/", "_blank"):
            window.open("https://www.bitfinex.com", "_blank");
          },
        },
      ],
      lang: "",
      showOnlieService: false,
      onlinePath: "",
    };
  },
  computed: {
    ...mapGetters(["existToken", "isLogin", "userInfo"]),
  },
  mounted() {
    // this.$set(
    //   this.linkNav[0].nav[0],
    //   "name",
    //   this.existToken
    //     ? this.$t("message.home.userCenter")
    //     : this.$t("message.home.login" /** 登录*/)
    // );
    // this.$set(
    //   this.linkNav[0].nav[0],
    //   "clickEvent",
    //   this.existToken
    //     ? () => this.$router.push("/userInfo/dashboard")
    //     : () => this.$router.push("/login")
    // );
    this.lang = localStorage.getItem("BIZ_LANG");
    this.getOnlinePath();
    this.bassEmail = this.$multiItem[process.env.VUE_APP_ITEM_NAME]?.mail;
     if(this.itemname == 'FamilyMart'){
      this.logoList = this.logoList.slice(1,6)
    }else if(this.itemname == 'Hive'|| process.env.VUE_APP_ITEM_NAME === 'TikTok-Wholesale'){
      this.logoList = this.logoList.slice(1,5)
      this.linkNav[3].nav = this.linkNav[3].nav.slice(0, 1)
    } else if( this.itemname == 'FamilyShop'){
      this.logoList = this.logoList.slice(0,6)
    } else if(this.itemname == 'SM-wholesale shop'){
      this.logoList = this.logoList.slice(0,2).concat(this.logoList.slice(4,8))
    }
    else {
      this.logoList = this.logoList.slice(0,8)
    }
   if(this.itemname == 'Green Mall'){
      this.linkNav = this.linkNav.slice(0,3)
   }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    identification(val) {
      // let codeReg = new RegExp("/[^\w\.\/]/ig"), //正则 英文+数字；
      //   len = val.length,
      //   str = "";
      // for (var i = 0; i < len; i++) {
      //   if (codeReg.test(val[i])) {
      //     str += val[i];
      //   }
      // }
      this.email = val;
    },
     async getOnlinePath() {
      // let res = await apiGetCustomerService({code:'customer_service_url'});
      // this.onlinePath = res.data.customer_service_url
    },
    async subScription() {
      var reg = /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/;
      var ret = reg.test(this.email);
      if (ret) {
        const res = await sub({ email: this.email });
        if (res.code == 0) {
          this.$message.success(
            this.$t("message.home.subscription") +
              this.$t("message.home.successTips")
          );
        }
      } else {
        this.$message.warning(this.$t("message.home.mailboxCheck"));
      }
    },
  },
};
</script>

<style lang="scss">
html[dir="rtl"]{
  .footer-nav{
    margin-left: 0;
    margin-right: 120px;
  }
  .tuodong{
    direction: ltr;
  }
}
.footer {
  background-color: var(--color-footer-bg);
  padding: 27px 20px;
  &-title {
    // border-bottom: 1px solid #3f3f3f;
    // padding-bottom: 30px;
    // margin-bottom: 27px;

    img {
      height: 65px;
      // height: 44px;
      margin-right: 9px;
      cursor: pointer;
    }
    h1 {
      color: var(--color-white);
      font-size: 20px;
      font-weight: 600;
      margin: 0;
    }
  }

  &-wrapper {
    align-items: flex-start !important;
    border-bottom: 1px solid #3f3f3f;
    padding: 0 40px;
    .footer-title {
      display: flex;
      flex-direction: column;
      align-items: inherit;
      p {
        // color: var(--color-main);
        color: var(--color-footer);
        font-size: 12px;
        margin-top: 26px;
      }
      .el-input__inner {
        width: 287px;
        height: 44px;
        margin: 12px 0 25px 0;
      }
      .sub {
        width: 156px;
        height: 42px;
        // color: var(--color-main);
        color: var(--color-footer);
        line-height: 42px;
        font-size: 12px;
        text-align: center;
        // border: 1px solid var(--color-main);
        border: 1px solid var(--color-footer);
        border-radius: 4px;
        cursor: pointer;
        will-change: filter;
        transition: filter 1300ms;
        &:hover {
          // background-color: var(--color-main);
          // filter: brightness(--color-footer);
          background-color: var(--color-footer);
          color: #fff;
        }
      }

    }
  }
  &-nav {
    width: 100%;
    display: flex;
    margin-left: 120px;
    &-item {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      span {
        font-size: 16px;
        font-weight: 700;
        // color: var(--color-main);
        color: var(--color-footer);
        margin-bottom: 37px;
      }
      ul {
        display: flex;
        list-style: none;
        flex-direction: column;
        li {
          margin-bottom: 37px;
          font-size: 12px;
          font-weight: 300;
          color: var(--color-white);
          cursor: pointer;
          &:hover {
            // color: var(--color-main);
            color: var(--color-footer);
          }
        }
      }
    }
  }
  .sec {
    padding-top: 20px;
    padding-bottom: 10px;
    justify-content: space-between;
    .payment {
      .title-f {
        font-size: 14px;
        color: #fff;
        // margin: 0 !important;
      }
      .payment-methods {
        display: flex;
        width: 348px;
        flex-wrap: wrap;
        justify-content: space-between;
        .pay {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 35px;
          width: 42px;
          cursor: pointer;
          &:hover span {
            // color: var(--color-main);
            color: var(--color-footer);
          }
          img {
            width: 32px;
            height: 32px;
            margin-bottom: 6px;
            margin-top: 15px;
          }
          span {
            font-size: 10px;
            color: #ababab;
          }
        }
      }
    }
    .argos {
      display: flex;
      .left {
        margin-left: 58px;
        margin-right: 68px;
        color: #fff;
        font-size: 12px;
        .title {
          font-size: 20px;
          font-weight: 600;
          margin: 19px 0 10px 0;
          color: #fff !important;
        }
        .dec {
          text-align: justify;
          word-break: break-all;
        }
      }
      .right{
        width: 230px;
        img{
          width: 230px;
        }
      }
    }
  }
  .sec-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 84px;
    margin-bottom: 28px;
    img {
      cursor: pointer;
      margin-right: 37px;
      max-height: 42px;
    }
  }
  .just-img {
    img {
      &:nth-child(7) {
        max-height: 58px !important;
      }
      // &:nth-child(1) {
      //   max-height: 18px !important;
      //   margin-top: 4px;
      // }
    }
  }
  // .just-img {
  //   img {
  //     &:nth-child(1) {
  //       transform: translate(4px, 7px);
  //     }
  //     &:nth-child(6) {
  //       max-height: 58px !important;
  //     }
  //   }
  // }
  &-bottom {
    font-size: 12px;
    padding: 22px 20px;
    color: #6b6b6b;
  }
}
</style>
